<script setup lang="ts">
  import { useTemplateRef } from 'vue'
  import StakeholderModalCreate from './modals/StakeholderModalCreate.vue'
  import {
    defineCreateStakeholderContext,
    provideCreateStakeholder,
    type CreateStakeholderProviderEmits
  } from '../../../composables/useCreateStakeholder'

  const emit = defineEmits<CreateStakeholderProviderEmits>()

  const modalStakeholderCreateRef = useTemplateRef('modalStakeholderCreate')

  const context = defineCreateStakeholderContext(
    {
      stakeholderCreate: modalStakeholderCreateRef
    },
    emit
  )

  provideCreateStakeholder(context)

  defineExpose(context)
</script>
<template>
  <slot />
  <StakeholderModalCreate ref="modalStakeholderCreate" />
</template>
